import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { MuiOverrideableProps } from '../../../type/MuiOverrideableProps';
import { ExtendButtonBaseTypeMap } from '@material-ui/core/ButtonBase/ButtonBase';
import { ButtonTypeMap } from '@material-ui/core/Button/Button';
import buttonWithIconStyles from './buttonWithIconStyles';
import usePlatformConfig from '../../../react/usePlatformConfig';

interface IButtonWithIcon {
  iconClasses?: string;
  labelClasses?: string;
  iconSize?: number;
  showIcon?: boolean;
}

const ButtonWithIcon: FunctionComponent<
  MuiOverrideableProps<ButtonProps, ExtendButtonBaseTypeMap<ButtonTypeMap>> & IButtonWithIcon
> = ({ className = '', children, iconSize = 30, iconClasses, labelClasses, showIcon, ...props }) => {
  const {
    platformConfig: { isComplexModel },
  } = usePlatformConfig();
  const styles = buttonWithIconStyles({ ...props, iconSize, hideIcon: isComplexModel && !showIcon });

  return (
    <Button
      {...props}
      className={[styles.root, className].join(' ')}
      variant={'contained'}
      classes={{
        label: labelClasses ?? '',
      }}
    >
      {children}
      {iconClasses && <span className={clsx([styles.icon, iconClasses, { [styles.disabledIcon]: props.disabled }])} />}
    </Button>
  );
};

export default ButtonWithIcon;
